<script setup lang="ts">
import { ref } from "vue"

const emit = defineEmits<Emits>()

const lastTarget = ref<EventTarget | null>()

const dropzoneRef = ref<HTMLElement>()

interface Emits {
  (event: "fileChanged", files: File[]): void
}

function isFile(event: DragEvent) {
  const dt = event.dataTransfer

  if (dt === null) {
    return false
  }

  return dt.types.includes("Files")
}

window.addEventListener("dragenter", (event) => {
  if (isFile(event) && dropzoneRef.value) {
    lastTarget.value = event.target
    dropzoneRef.value.style.visibility = ""
    dropzoneRef.value.style.opacity = "1"
  }
})

window.addEventListener("dragleave", (event) => {
  event.preventDefault()
  if (
    dropzoneRef.value &&
    (event.target === lastTarget.value || event.target === document)
  ) {
    dropzoneRef.value.style.visibility = "hidden"
    dropzoneRef.value.style.opacity = "0"
  }
})

window.addEventListener("dragover", (event) => {
  event.preventDefault()
})

window.addEventListener("drop", (event) => {
  event.preventDefault()
  if (dropzoneRef.value) {
    dropzoneRef.value.style.visibility = "hidden"
    dropzoneRef.value.style.opacity = "0"
  }

  if (
    event.dataTransfer?.files !== undefined &&
    event.dataTransfer.files.length > 0
  ) {
    // Convert FileList to an Array of File objects.
    emit("fileChanged", Array.from(event.dataTransfer?.files))
  }
})
</script>

<template>
  <div
    ref="dropzoneRef"
    style="visibility: hidden; opacity: 0"
    class="fixed inset-0 z-9999 grid content-center bg-black/50 text-center text-4xl text-white transition-colors"
  >
    <div>Drop anywhere!</div>
  </div>
</template>
